/**
 * Константы этапов воронки (Cooperation Stages)
 *
 * Единый источник правды для цветов и названий этапов.
 * Используется в: ProgressPath, FunnelAreaChart, OrganizationsTable
 */

export const COOPERATION_STAGES = [
  { code: 'new', name: 'Новый', shortName: 'Новый', color: '#0176D3' },
  { code: 'message_sent', name: 'Отправлено сообщение', shortName: 'Сообщ.', color: '#7DC681' },
  { code: 'call', name: 'Звонок', shortName: 'Звонок', color: '#5EBA62' },
  { code: 'meeting', name: 'Встреча', shortName: 'Встреча', color: '#48A84C' },
  { code: 'master_class', name: 'Мастер-класс', shortName: 'МК', color: '#3D9141' },
  { code: 'contract_signed', name: 'Заключение договора', shortName: 'Договор', color: '#2E7D32' },
  { code: 'classes_active', name: 'Идут занятия', shortName: 'Занятия', color: '#1B5E20' },
  { code: 'classes_paused', name: 'Приостановка', shortName: 'Пауза', color: '#FFA000' },
  { code: 'contract_terminated', name: 'Договор расторгнут', shortName: 'Растор.', color: '#C62828' },
  { code: 'cooperation_refused', name: 'Отказ', shortName: 'Отказ', color: '#800020' },
];

// Цвет для линии "Всего"
export const TOTAL_LINE_COLOR = '#374151';

// Маппинг кода в метаданные
export const STAGE_BY_CODE = COOPERATION_STAGES.reduce((acc, stage) => {
  acc[stage.code] = stage;
  return acc;
}, {});

// Периоды для селектора
export const PERIOD_OPTIONS = [
  { value: 'month', label: 'Месяц' },
  { value: '3months', label: '3 месяца' },
  { value: '6months', label: '6 месяцев' },
  { value: 'year', label: 'Год' },
];

// Гранулярность для селектора
export const GRANULARITY_OPTIONS = [
  { value: 'daily', label: 'День' },
  { value: 'weekly', label: 'Неделя' },
  { value: 'monthly', label: 'Месяц' },
];

export default COOPERATION_STAGES;
